import { get } from 'lodash'
import { requiredCheck } from 'utils/validation'

const validate = (values, props) => {
  const errors = {
    helpers: {}
  }

  // errors.helpers.photosConsent = requiredCheck(
  //   get(values, 'helpers.photosConsent')
  // )
  errors.helpers.terms = requiredCheck(get(values, 'helpers.terms'))

  if (props.hasPolicy) {
    errors.helpers.agreementPrivacyPolicy = requiredCheck(
      get(values, 'helpers.agreementPrivacyPolicy')
    )
  }

  return errors
}

export default validate
